import { Component, OnInit } from "@angular/core";
import { AbstractPage } from "../AbstractPage";
import { LoadingController, ModalController, NavController, NavParams } from "@ionic/angular";
import { Router } from "@angular/router";
import { Studente } from "../models/didattica/studente";
import { TranslateService } from "@ngx-translate/core";
import { IdoneitaService } from "../services/idoneita-service";
import { Idoneita } from "../models/idoneita/idoneita";
import { IdoneitaStudente } from "../models/idoneita/Idoneita-studente";

@Component({
    selector: 'app-elenco-blocco-cancellazioni',
    templateUrl: './elenco-blocco-cancellazioni.page.html',
    styleUrls: ['./elenco-blocco-cancellazioni.page.scss']
  })
export class ElencoBlocchiCancellazionePage extends AbstractPage implements OnInit {

  idoneita: Idoneita;
  emptyStuds: boolean;
  studenti: Studente[] = [];
  idoneitaStudenti: IdoneitaStudente[];


    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public router: Router,
        public modalCtrl: ModalController,
        public idoneitaService: IdoneitaService,
        public loadingCtrl: LoadingController,
        public translateService: TranslateService
    ) {
        super(navCtrl, router);
        this.idoneita = this.navParams.data.idoneita;
    }

    async ngOnInit() {
        console.log('ngOnInit ElencoBloccoCancellazioniPage');   
        await this.recuperaElencoBloccoCancellazioni();
    }
    
    cancel() {
        this.modalCtrl.dismiss();
    }

    async recuperaElencoBloccoCancellazioni() {
      const loader = await this.loadingCtrl.create({
        message: this.translateService.instant('label.richiestaincorso')
      });
      loader.present(); 
      this.idoneitaService.cercaRichiesetBloccoCancellazione(this.idoneita).subscribe(idoneitaStudenti => { 
        this.idoneitaStudenti = idoneitaStudenti;
        if (this.idoneitaStudenti.length === 0) {
          this.emptyStuds = true;
        }
        loader.dismiss(); 
      });
    }

    //   async cercaPresenti() {
    //     let matricole_ = [];
    //     this.studenti = [];
    //     this.studentiCaricati = [];
    //     let studentiErr = [];
    //     for(const mat of matricole) {
    //         if(mat !== '' && mat.length <= 20 && !matricole_.includes(mat)) {
    //             matricole_.push(mat);
    //             this.form.controls['studenti'].setValue(true);
    //             this.form.controls['all'].setValue(true);
    //         }
    //     }   
    //     const loader = await this.loadingCtrl.create({
    //         message: this.translateService.instant('label.richiestaincorso')
    //       });
    //       loader.present(); 
    //     this.rilevazionePresenzeService.cercaStudenti(matricole_).subscribe(stu => {
    //         stu.forEach(studente => {
    //           if(studente.id !== null) {
    //             this.studenti.push(studente);
    //             this.studentiCaricati.push(studente);
    //           }
    //           else {
    //             studentiErr.push(studente);
    //             this.studentiError = this.studentiError.concat(studente.matricola + "; ");
    //           }
    //         });

    //         if(stu.length === 0 || studentiErr.length === stu.length) {
    //           this.noValidStu = true;
    //         }
    //         else {
    //           this.noValidStu = false;
    //         }

    //         if(this.studentiError !== null) {
    //           this.infoMessage = this.translateService.instant('carica-presenza.label.studenti.error', { n: this.studentiError });
    //         }
    //         loader.dismiss();
    //     });
    //     this.checkDuplicate();
    //   }

    // aggiungiStudente(studente: Studente) {
    //     console.log('studente', this.form.controls['studenti'].value);
    //     if(this.form.controls['studenti'].value) {
    //       this.studentiCaricati.push(studente);
    //     }
    //     else {
    //       let index = this.studentiCaricati.indexOf(studente);
    //       this.studentiCaricati.splice(index, 1);
    //     }
    //   }

    //   async conferma() {
    //     await this.modalCtrl.dismiss(this.studentiCaricati);
    //   }

    //   selectAll() {
    //     if(this.form.controls['all'].value) {
    //       this.form.controls['studenti'].setValue(true);
    //       this.studentiCaricati = [];
    //       this.studenti.forEach(studente => {
    //         this.studentiCaricati.push(studente);
    //       })
    //     }
    //     else {
    //       this.form.controls['studenti'].setValue(false);
    //       this.studentiCaricati = [];
    //     }
    //   }

    //   checkDuplicate() {
    //     this.duplicates = this.matricole.filter((a, i, aa) => aa.indexOf(a) === i && aa.lastIndexOf(a) !== i);

    //     if(this.duplicates.length != 0) {
    //       this.dupMessage = this.translateService.instant('carica-presenza.label.studenti.duplicates', { n: this.duplicates });
    //     }
    //   }
}